import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import debounce from 'lodash/debounce'
import { styles } from './Youtube.style'
import { loadYoutube } from '../third_party/Youtube.jsx'

const DEFAULT_WIDTH = 640
const DEFAULT_HEIGHT = 360

class Youtube extends React.PureComponent {
  constructor(props) {
    super(props)
    const { width, height } = props
    this.state = {
      adaptMarginTop: 0,
      adaptWidth: width || DEFAULT_WIDTH,
      adaptHeight: height || DEFAULT_HEIGHT,
      playerState: null,
    }
  }

  debounceReize = debounce(() => this.handleResize(), 100)

  async componentDidMount() {
    await loadYoutube('youtube-script')
    if (Youtube.YT) {
      this.handleResize(this.initializeYoutube)
    } else {
      window.onYouTubeIframeAPIReady = () => {
        Youtube.YT = window.YT
        this.handleResize(this.initializeYoutube)
        window.onYouTubeIframeAPIReady = null
        window.YT = null
      }
    }
  }

  initializeYoutube() {
    const { id, videoId } = this.props
    const { adaptWidth, adaptHeight } = this.state
    this.player = new Youtube.YT.Player(id, {
      width: adaptWidth || DEFAULT_WIDTH,
      height: adaptHeight || DEFAULT_HEIGHT,
      videoId,
      playerVars: {
        autoplay: 1,
        controls: 0,
        loop: 1,
        disablekb: 1,
        muted: 1,
        playsinline: 1,
        'webkit-playsinline': 1,
      },
      events: {
        onReady: this.onPlayerReady,
        onStateChange: this.onPlayerStateChange,
      },
    })
    window.addEventListener('resize', this.debounceReize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.debounceReize)
    this.player = null
  }

  handleResize = (cb) => {
    if (this.parent) {
      const { adaptWidth, adaptHeight } = this.state
      const parentWidth = this.parent.clientWidth
      const parentHeight = this.parent.clientHeight
      const ratio = adaptWidth / adaptHeight
      const parentRatio = parentWidth / parentHeight
      if (parentRatio > ratio) {
        const newHeight = parentWidth / ratio
        const marginTop = -(newHeight - parentHeight) / 2
        this.setState(
          {
            adaptMarginTop: marginTop,
            adaptWidth: parentWidth,
            adaptHeight: newHeight,
          },
          cb
        )
      } else {
        const newWidth = parentHeight * ratio
        const marginLeft = -newWidth / 2
        this.setState(
          {
            adaptMarginTop: -100,
            adaptMarginLeft: marginLeft,
            adaptWidth: parentHeight * ratio * 1.5,
            adaptHeight: parentHeight * 1.5,
          },
          cb
        )
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('no parent')
    }
  }

  onPlayerReady = (e) => {
    const { onPlayerReady } = this.props
    e.target.playVideo()
    e.target.mute()
    onPlayerReady && onPlayerReady(e.target)
  }

  onPlayerStateChange = (e) => {
    const { onPlayerStateChange } = this.props
    this.setState({
      playerState: e.data,
    })

    onPlayerStateChange && onPlayerStateChange(e.data)

    if (e.data == Youtube.YT.PlayerState.ENDED) {
      this.player.playVideo()
    }
  }

  getRef = (node) => {
    this.container = node
    this.parent = node && node.parentNode
  }

  render() {
    const { id, classes } = this.props
    const { adaptWidth, adaptHeight, adaptMarginTop, adaptMarginLeft } = this.state
    return (
      <div
        className={classes.container}
        style={{
          width: adaptWidth,
          height: adaptHeight,
          marginTop: adaptMarginTop,
          marginLeft: adaptMarginLeft,
        }}
        ref={this.getRef}>
        <div id={id} style={{ width: '100%', height: '100%' }}></div>
        <div
          className={classNames(classes.layover, {
            [classes.layoverHidden]:
              Youtube.YT && this.state.playerState === Youtube.YT.PlayerState.PLAYING,
          })}></div>
      </div>
    )
  }
}

export default withStyles(styles)(Youtube)
